
import Swal from 'sweetalert2'

export default{
   
    servidor : 'https://dmini.sistemizeapps.com/r-rep',
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    reqaxios(parametros, metodo, url){
        let axios        = require('axios');
        let bodyFormData = new FormData(); 

        for (let i = 0; i < parametros.length; i++){
            let pmt = parametros[i].parametro;
            let vl  = parametros[i].valor;
            bodyFormData.append(pmt, vl);    
        }
        return axios({
            method: metodo,
          
            url : url,
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }            
        });           
    }, 
    notif(tipo, titulo, texto){

        if(tipo == 'error'){
            Swal.fire({
                icon: "error",
                title: titulo,
                text: texto
              });
        }else{
            Swal.fire({
                position: "top-end",
                title: titulo,
                text: texto,
                showConfirmButton: false,
                timer: 1500,
                icon: tipo
              });
        }
    },
    formatavalordecimais(valor, digitos) {
        //return valor.toLocaleString('pt-br', {minimumFractionDigits: digitos});
        //return valor.toFixed(digitos).replace('.', ',');        
        return valor.formatMoney(digitos, "", ".", ",");
    },    
    formatarvalor(value, cifra) {
        var val = (value / 1).toFixed(2).replace('.', ',');
        if (cifra == '') {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return cifra + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
    gerardadoslegendagrafico(arraydados){
        let dadoslegenda = [];
        for (let item of arraydados) {
            dadoslegenda.push(item.name);
        }
        return dadoslegenda;
    },
    resetZoom() {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
          metaViewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
        }
    },
    atzdash(){
        document.getElementById("btdash").click();
    },
    DataBRtoObJ(dataStr){
        const partes = dataStr.split('/');
        if (partes.length !== 3) return null; // Retorna null se o formato estiver incorreto

        const dia = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1; // Mês no JS começa do zero (jan = 0)
        const ano = parseInt(partes[2], 10);

        return new Date(ano, mes, dia);
    },
    logoff(){
        window.localStorage.clear();
        location.reload();
    },
    getArrayIndexForKey(arr, key, val) {//pega o índice de uma array pela chave
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][key] == val) return i;
        }
        return -1;
    },
    findValInArray(arr, key, val) {//verifica se existe um valor em uma chave de uma array
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][key] == val) return true;
            }
        }
        return false;
    },
    getValInArray(arr, key, val, keyret) {//verifica se existe um valor em uma chave de uma array
        let valret = 0;
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                let valkey = arr[i][key];
                if (valkey == val) {
                    return arr[i][keyret];
                }
            }
        }
        return valret;
    },
    limparCpfCnpj(valor){
        return valor.replace(/[.\-\/]/g, '');
    },
    IsCEP(strCEP, blnVazio) {
        // Caso o CEP não esteja nesse formato ele é inválido!
        let objER   = /^[0-9]{2}[0-9]{3}-[0-9]{3}$/;
        strCEP      = this.Trim(strCEP)
        if (strCEP.length > 0) {
            if (objER.test(strCEP))
                return true;
            else
                return false;
        }
        else
            return blnVazio;
    },
     Trim(strTexto) {
        // Substitúi os espaços vazios no inicio e no fim da string por vazio.
        return strTexto.replace(/^s+|s+$/g, '');
    },
    GerarStringAleatoria() {
        let chars      = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let tamanho    = chars.length;
        let straleat   = "";
        for (let i = 0; i < 15; i++) {
            straleat += chars.charAt(Math.floor(Math.random() * tamanho));
        }
        return straleat;
    }
}   